<template>
    <div v-if="user && $route.meta.headerCheckout !== false && $root.source !== 'enel'">
      <v-btn :class="{'mx-3': $mq.isDesktop()}" color="var(--quomi-primary)"  outlined v-if="canShow" @click="changeDelivery" style='text-transform: inherit'>
        <span class="city"  style='text-transform:capitalize' v-show="showCity">{{ address.city.toLowerCase() }} |</span><i class="fa fa-truck mx-2"></i> {{ $_dates_readableShortDate(order.date.delivery).toLowerCase() }} <i class="fas fa-chevron-down ml-2"></i>
      </v-btn>
    </div>
</template>

<script type="text/javascript">

import { container } from '../../services/container'
import { orderStore } from '../../store/orderStore'
import { UserApi } from '../../api/UserApi'
import { dates } from '../../mixins/dates'
import { deliveryStore } from '../../store/deliveryStore'
import { shipmentDayChanging } from '../../mixins/shipmentDayChanging'

export default {
  props: {
    showCity: {
      type: Boolean,
      default: true
    }
  },
	data () {
		return {
      loading: false,
      value: false,
      deliveryStore: deliveryStore.state
		}
	},
  mixins: [
    dates,
    shipmentDayChanging,
  ],
  computed: {
    canShow() {
      return this.order && this.address && this.delivery// && (!this.order.date.confirmed_at)
    },
    address () {

        return this.delivery 
            && this.deliveryStore.address
            && this.deliveryStore.address.delivery
            && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id)
            && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id).attributes
    },

    delivery () {

        if (!this.user) {
          return null
        }
        
        var sub = this.user.subscription

        return this.deliveryStore
            && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id)
            && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id).attributes
    },

    user() {
      return this.$root.user
    },
    order() {
      return this.user ? this.user.order : null;
    }
  },
  methods: {
    changeDelivery() {

      window.dispatchEvent(new CustomEvent('delivery-change', { 
        bubbles: true, 
        detail: true 
      }));
    }
  },
  mounted() {
    if (!this.address) {
      this.$_shipmentDayChanging_loadDelivery()
    }
  }
}
</script>
<style scoped>
  .city {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width:200px;
    display:inline-block
  }
</style>